import { render, staticRenderFns } from "./FailedDataGet.vue?vue&type=template&id=37622e5f"
import script from "./FailedDataGet.vue?vue&type=script&lang=js"
export * from "./FailedDataGet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports